import { Component, Input } from '@angular/core';
import { PMFormatGuarantor } from '../../../../data/interfaces/circle-credit.interface';

@Component({
  selector: 'app-circle-credit-guarantor-card',
  templateUrl: './circle-credit-guarantor-card.component.html',
  styleUrls: ['./circle-credit-guarantor-card.component.scss']
})
export class CircleCreditGuarantorCardComponent {
  @Input() data: PMFormatGuarantor | null = null;

  get hasData(): boolean {
    if (!this.data) return false;
    return !!(this.data.companyName || this.data.rfc || this.data.firstName);
  }

  get completionPercentage(): number {
    if (!this.data) return 0;
    
    const allFields = [
      'rfc', 'companyName', 'firstName', 'address1', 
      'city', 'state', 'phone', 'clientType'
    ];
    const filledFields = allFields.filter(field => this.data![field as keyof PMFormatGuarantor]);
    return Math.round((filledFields.length / allFields.length) * 100);
  }

  get statusClass(): string {
    if (!this.hasData) return 'status-empty';
    const percentage = this.completionPercentage;
    if (percentage < 30) return 'status-incomplete';
    if (percentage < 70) return 'status-partial';
    return 'status-complete';
  }

  get guarantorName(): string {
    if (!this.data) return 'No especificado';
    
    if (this.data.companyName) {
      return this.data.companyName;
    }
    
    const parts = [
      this.data.firstName,
      this.data.middleName,
      this.data.lastNameFatherGuarantor,
      this.data.lastNameMotherGuarantor
    ].filter(part => part && part.trim());
    
    return parts.join(' ') || 'No especificado';
  }

  get fullAddress(): string {
    if (!this.data) return 'No especificado';
    
    const parts = [
      this.data.address1,
      this.data.address2,
      this.data.neighborhood,
      this.data.municipality,
      this.data.city,
      this.data.state,
      this.data.postalCode
    ].filter(part => part && part.trim());
    
    return parts.join(', ') || 'No especificado';
  }

  formatPhone(phone: string | undefined): string {
    if (!phone) return 'No especificado';
    
    // Formato básico para teléfonos mexicanos
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  }

  get guarantorType(): 'company' | 'individual' {
    return this.data?.companyName ? 'company' : 'individual';
  }

  get isComplete(): boolean {
    if (!this.data) return false;
    
    const essentialFields = [
      this.data.rfc,
      this.guarantorName !== 'No especificado' ? this.guarantorName : null,
      this.data.phone,
      this.fullAddress !== 'No especificado' ? this.fullAddress : null
    ];
    
    return essentialFields.filter(field => field).length >= 3;
  }
}
